import { Controller } from "@hotwired/stimulus"

// Clearing empties the field and tells the page, the same as deleting the
// text by hand.
export default class extends Controller {
  static targets = ["input"]

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.inputTarget.focus()
  }
}
